import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-fabrics-grp',
  templateUrl: './fabrics-grp.component.html',
  styleUrls: ['./fabrics-grp.component.css']
})
export class FabricsGrpComponent implements OnInit {
    public fabricsGrpId: string;

    public edit?: Edit;

    public saving = false;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.fabricsGrpId = this.stateService.getStateParams()['fabricsgrp_id'];
    }

    private async loadEdit() {
        if (!!this.fabricsGrpId) {
            this.edit = (await this.datatask.Post(1241, { fabricsgrp_id: this.fabricsGrpId }))[0];
        }
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                await this.datatask.Post(1242, this.edit);

                this.stateService.back();
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    fabricsgrp_id: string;
    fabricsgrp_name: string;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('fabricsGrp', {
//        templateUrl: 'views/components/views/fabricsGrp/fabricsGrp.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'fabricsGrpService', function ($stateParams, stateService, fabricsGrpService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let fabricsGrpId = $stateParams.fabricsgrp_id;

//            vm.model = {
//                fabricsGrpId: fabricsGrpId,
//                edit: {},
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadEdit() {
//                vm.model.edit = (await fabricsGrpService.getEdit({ fabricsgrp_id: fabricsGrpId }))[0];
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                fabricsGrpService.saveObj(vm.model.edit).then(function () {
//                    vm.model.lockedSave = false;
//                    stateService.back();
//                }, function () {
//                    vm.model.lockedSave = false;
//                });
//            };

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadEdit();
//            };

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
